export const VALID_ZOOMS = [14, 15, 16, 17, 18, 19, 20];

export interface TileFile {
	file: File;
	tilePath: string;
}

export function normalizeTilePath(rawPath: string): string | null {
	const match = rawPath
		.replace(/\\/g, '/')
		.match(/(?:^|\/)(\d+)\/(\d+)\/(\d+)\.(png|jpg|jpeg)$/i);
	if (!match) return null;

	const zoom = parseInt(match[1], 10);
	if (!VALID_ZOOMS.includes(zoom)) return null;

	return `${match[1]}/${match[2]}/${match[3]}.${match[4].toLowerCase()}`;
}

export function toTileFiles(
	entries: { file: File; relativePath: string }[],
): TileFile[] {
	const tiles: TileFile[] = [];
	const seen = new Set<string>();

	for (const { file, relativePath } of entries) {
		const tilePath = normalizeTilePath(relativePath || file.name);
		if (!tilePath) continue;

		if (seen.has(tilePath)) continue;
		seen.add(tilePath);
		tiles.push({ file, tilePath });
	}

	return tiles;
}

export function chunk<T>(items: T[], size: number): T[][] {
	const out: T[][] = [];
	for (let i = 0; i < items.length; i += size) {
		out.push(items.slice(i, i + size));
	}
	return out;
}
